import * as React from 'react';

const LAPTOP_BREAKPOINT = 1440;

// Ler `window.innerWidth` sincronamente no lazy initializer garante que o primeiro render já
// enxerga o breakpoint correto — evita CLS de sidebar (transition-[width] disparado quando o
// state passava de `false` (default) para o valor real após o effect hidratar).
const getInitialIsLaptop = (breakpoint: number): boolean => typeof window !== 'undefined' && window.innerWidth < breakpoint;

export function useIsLaptop({ breakpoint = LAPTOP_BREAKPOINT }: { breakpoint?: number } = {}) {
  const [isLaptop, setIsLaptop] = React.useState<boolean>(() => getInitialIsLaptop(breakpoint));

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => {
      setIsLaptop(window.innerWidth < breakpoint);
    };
    mql.addEventListener('change', onChange);
    // Ressincroniza caso a viewport tenha mudado entre o initializer e o mount (ex.: resize
    // durante hidratação).
    setIsLaptop(window.innerWidth < breakpoint);
    return () => mql.removeEventListener('change', onChange);
  }, [breakpoint]);

  return isLaptop;
}
